import { type Ref, type UnwrapRef, ref, watch } from "vue";
import { type SimpleProductListQuery } from "./types";
import { type State } from "./product-list/list-controller";

type ProductListStateStore = {
    [key: string]: Ref<UnwrapRef<StoreItem>>;
};

interface ListStateObject {
    submit(byFilter: boolean): void;
    hasCustomHeader?: boolean;
}

export type StoreItem = {
    query: SimpleProductListQuery;
    segmentState: State;
    filter?: {
        resolveUrlAndCall(callback: () => void): void;
        submit(): void;
        collectionViewMode: number | undefined;
    };
    list?: ListStateObject;
    whenListReady?: (list: ListStateObject) => void;
    loading: boolean;
    mln?: MatchedLogicalNameData;
};

export type MatchedLogicalNameData = {
    matchedLogicalName: string | undefined | null;
    matchedLogicalNameModuleGuid: number | undefined | null;
    matchedLogicalNameSubModuleGuid: number | undefined | null;
};

const store: ProductListStateStore = {};

let applyWatch: ((key: string, storeItem: Ref<StoreItem>) => void) | undefined;

export function getProductListState(filterId: string) {
    if (!(filterId in store && store[filterId] != null)) {
        const storeItemRef = ref<StoreItem>({
            query: {
                collectionIds: [],
                sorting: "EndDateAsc",
            },
            segmentState: {},
            loading: false,
        });
        if (applyWatch != null) applyWatch(filterId, storeItemRef);
        store[filterId] = storeItemRef;
    }
    return store[filterId];
}

window.addEventListener(
    "message",
    (event) => {
        if (event.data == null) return;
        if (typeof event.data !== "string") return;
        if (event.data === "sub:listState") {
            const src = event.source;
            const origin = event.origin;

            const watchListState = (key: string, storeItem: Ref<StoreItem>) => {
                console.log("now watching " + key);
                watch(
                    () => storeItem.value,
                    (newValue) => {
                        const value = JSON.parse(JSON.stringify(newValue));
                        console.log("MSG: POST MESSAGE BACK TO SOURCE", value);
                        src?.postMessage(
                            {
                                type: "upd:listState",
                                key: key,
                                value: value,
                            },
                            {
                                targetOrigin: origin,
                            }
                        );
                    },
                    {
                        immediate: true,
                        deep: true,
                    }
                );
            };

            for (const key of Object.keys(store)) {
                watchListState(key, store[key]);
            }

            applyWatch = watchListState;

            console.log("MSG: CONFIRM SUB");
            src?.postMessage(
                {
                    type: "accept",
                    value: "sub:listState",
                },
                {
                    targetOrigin: origin,
                }
            );
        }
    },
    false
);
